import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, LayoutGrid, User, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export default function MobileBottomNav() {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const authed = user && user.user_id;

  const base = "flex flex-col items-center justify-center gap-1 flex-1 py-2.5 text-[9px] uppercase tracking-[0.12em] transition-colors";
  const cls = (active) => `${base} ${active ? "text-[#4ADE80]" : "text-[#A8A8A8]"}`;

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0F0F10]/90 backdrop-blur-xl border-t border-white/10 flex items-stretch px-2 pb-[env(safe-area-inset-bottom)]"
    >
      <NavLink to="/" data-testid="mobnav-home" className={cls(pathname === "/")}>
        <Home className="h-5 w-5" strokeWidth={1.5} /> Home
      </NavLink>
      <NavLink to="/products" data-testid="mobnav-search" className={cls(pathname === "/products")}>
        <Search className="h-5 w-5" strokeWidth={1.5} /> Search
      </NavLink>
      <NavLink to="/products" data-testid="mobnav-shop" className={cls(false)}>
        <LayoutGrid className="h-5 w-5" strokeWidth={1.5} /> Shop
      </NavLink>
      <NavLink to={authed ? "/account" : "/login"} data-testid="mobnav-account" className={cls(pathname === "/account")}>
        <User className="h-5 w-5" strokeWidth={1.5} /> Account
      </NavLink>
      <button data-testid="mobnav-cart" onClick={() => setOpen(true)} className={`${base} text-[#A8A8A8]`}>
        <span className="relative">
          <ShoppingBag className="h-5 w-5" strokeWidth={1.5} />
          {count > 0 && (
            <span className="absolute -top-2 -right-2 h-4 min-w-4 px-1 bg-[#4ADE80] text-[#0F0F10] text-[9px] font-medium flex items-center justify-center">{count}</span>
          )}
        </span>
        Cart
      </button>
    </nav>
  );
}
